module.exports = __webpack_public_path__ + "media/images/photo/top/album/album2-b6df5e888d58c1f57e897b824cbaf3c3.jpg";